import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const TransformationSection = () => {
  return <section className="bg-terracotta text-white px-4 py-10 md:py-20 lg:px-8" data-id="element-237">
      <div className="mx-auto max-w-5xl" data-id="element-238">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center" data-id="element-239">
          <h2 className="mb-8 font-serif text-3xl font-bold md:text-5xl" data-id="element-240">
            ¿Y si la hora de la cena se viera así?
          </h2>
          <div className="mx-auto max-w-3xl space-y-6 text-lg leading-relaxed md:text-xl" data-id="element-241">
            <p data-id="element-242">
              En lugar de luchar contra el reloj, simplemente activas tu cena
              protegida y listo. Puedes acurrucarte con tus hijos, hablar con tu
              pareja y dejar de estresarte por el tiempo. Tienes muchos menos
              platos que lavar, así que por una vez terminas temprano en la
              cocina.
            </p>
            <p className="font-bold text-highlight" data-id="element-243">
              Amiga, absolutamente puedes tener la cena en la mesa cada noche
              sin sentir que te vas a arrancar el pelo. ¡Lo sé porque yo he
              estado ahí!
            </p>
          </div>
        </motion.div>

        {/* Testimonial Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mx-auto max-w-3xl rounded-2xl bg-white/10 p-8 backdrop-blur-sm md:p-10" data-id="element-244">
          <div className="mb-6 flex justify-center space-x-1" data-id="element-245">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-6 w-6 fill-yellow-400 text-yellow-400" data-id="element-246" />)}
          </div>

          <blockquote className="mb-6 text-center text-lg italic leading-relaxed text-white/90 md:text-xl" data-id="element-247">
            "¡Maravilloso! Soy nueva en la preparación de comidas, pero como
            mamá trabajadora, necesitaba ayuda. Me encanta cocinar pero no tengo
            tiempo. Esta guía no solo me hizo la vida más fácil; ¡a mi hijo
            súper quisquilloso le encantan casi todos los platos! El Escudo de
            Frescura realmente hace que la comida sepa como si acabara de
            hacerse desde cero."
          </blockquote>

          <div className="text-center font-bold text-highlight" data-id="element-248">
            — Claudia, compradora del Paquete Completo.
          </div>
        </motion.div>
      </div>
    </section>;
};